export class StrutturaVO {
  id: string;
  idLista: string;
  nome: string;
  responsabile: any;
  output: string;
  tipo: string;
  children: number;
}


